import { createComponent } from '@carvana/merch-components';

export const EvCarouselSection = createComponent('section', {
  className: 'px-2xl pb-2xl pt-3xl sm:pl-3xl sm:pt-4xl md:px-[84px] md:py-4xl'
});
